import Custom from "../../../Components/Buttons/Custom";
import { toPersianDigits } from "../../../helper/toPersianDigits";

export default function NotifModal({ onClose, data }) {
  const timeAgo = (isoString) => {
    const now = new Date();
    const past = new Date(isoString);

    const diffMs = now - past; // milliseconds difference
    const diffSec = Math.floor(diffMs / 1000);
    const diffMin = Math.floor(diffSec / 60);
    const diffHr = Math.floor(diffMin / 60);
    const diffDay = Math.floor(diffHr / 24);
    const diffMon = Math.floor(diffDay / 30);
    const diffYr = Math.floor(diffDay / 365);

    if (diffSec < 60) return `${diffSec} ثانیه پیش`;
    if (diffMin < 60) return `${diffMin} دقیقه پیش`;
    if (diffHr < 24) return `${diffHr} ساعت پیش`;
    if (diffDay < 30) return `${diffDay} روز پیش`;
    if (diffMon < 12) return `${diffMon} ماه پیش`;
    return `${diffYr} سال پیش`;
  };
  return (
    <div className="p-5 w-full max-w-2xl max-h-96 rounded-2xl flex flex-col gap-6 bg-zi-bg2-light dark:bg-zi-bg2-dark drop-shadow-lg">
      <div className="w-full flex items-center justify-between gap-1">
        <h5 className="font-medium text-base sm:text-xl text-zi-text-light dark:text-zi-text-dark overflow-hidden whitespace-nowrap text-ellipsis">
          {data?.title || ""}
        </h5>
        <span className="text-xs text-nowrap text-zi-text-light/50 dark:text-zi-text-dark/50">
          {data ? toPersianDigits(timeAgo(data.created_at)) : ""}
        </span>
      </div>

      <div className="w-full min-w-0 flex items-center gap-1 sm:gap-5 text-justify text-sm sm:text-base overflow-y-auto">
        <p className="flex-1 min-w-0 text-zi-text-light dark:text-zi-text-dark leading-relaxed">
          {data?.description || ""}
        </p>
      </div>

      <div onClick={onClose}>
        <Custom
          text="بستن"
          className="bg-zi-buttonbg-primary mt-6 text-zi-text-dark w-full hocus:opacity-85"
        />
      </div>
    </div>
  );
}
